module.exports = __webpack_public_path__ + "static/media/face_masked_doctor.eda13af4.jpg";